//@flow

// Vendors
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { push } from 'connected-react-router';

//Actions
import { setTakeoverNavContent } from '../../../../../../reducers/navbar/navbarActions';

// Components
import {
  FormActions,
  FormActionsItem,
  Trans,
  InputCheckbox,
} from '../../../../../../components';
import { ButtonPrimary, Button } from 'texkit/dist/components/Buttons';
import SummaryCard from 'texkit/dist/components/Cards/SummaryCard/SummaryCard';
import './CDLLRConfirmDetails.scss';

// Types
type Props = {
  license: Object,
  push: Function,
  dispatch: Function,
  setTakeoverNavContent: Function,
};

type State = {
  isTermsChecked: boolean,
};

class CDLLRConfirmDetails extends Component<Props, State> {
  state = {
    isTermsChecked: false,
  };

  async handleConfirmClick() {
    this.props.push('/dpslr');
  }

  handleCancelClick() {
    this.props.push('/agency/dps');
  }

  handleCheckboxChange(e) {
    this.setState({ isTermsChecked: !e.target.value });
  }

  componentWillMount() {
    this.props.setTakeoverNavContent({
      title: {
        file: 'dps',
        id: 'dps_RenewDriverLicense',
      },
    });
  }

  render() {
    const { license } = this.props;
    const { isTermsChecked } = this.state;
    const {
      firstName,
      middleName,
      lastName,
      suffix,
    } = license.personalInformation;

    if (!license) return <Redirect to="/agency/dps" />;

    return (
      <>
        <div className="page confirm-details" role="main">
          <div className="Rectangle">
            <div className="agency-card-text">
              <h2 className="h3">
                <Trans file="dps" id="AgencyName" />
              </h2>
            </div>
          </div>
          <h1 className="h2">
            <Trans
              file="dps"
              id="cdl_Confirm_Detais"
              fallback="cdl_Confirm_Detais"
            />
          </h1>
          <p className="">
            <Trans
              file="dps"
              id="cdl_ConfirmDetailsNote"
              fallback="cdl_ConfirmDetailsNote"
            />
          </p>
          <SummaryCard>
            <SummaryCard.List
              items={[
                {
                  label: <Trans file="Labels" id="Name" fallback="Name" />,
                  value: `${firstName ? firstName : ''}
                              ${middleName ? middleName : ''}
                              ${lastName ? lastName : ''}
                              ${suffix ? suffix : ''}`,
                  className: 'word-break',
                },
                {
                  label: (
                    <Trans
                      file="Labels"
                      id="CommercialDriverLicense"
                      fallback="CommercialDriverLicense"
                    />
                  ),
                  value: license.dlIdNumber,
                },
                {
                  label: <Trans file="Labels" id="Class" fallback="Class" />,
                  value: license.licenseClass,
                },
                {
                  label: (
                    <Trans
                      file="Labels"
                      id="RestrictionCodes"
                      fallback="RestrictionCodes"
                    />
                  ),
                  value: license.cdlInformation.restrictionCodes ? (
                    license.cdlInformation.restrictionCodes
                  ) : (
                    <Trans file="Labels" id="None" fallback="None" />
                  ),
                },
                {
                  label: (
                    <Trans
                      file="Labels"
                      id="EndorsementCodes"
                      fallback="EndorsementCodes"
                    />
                  ),
                  value: license.cdlInformation.endorsementCodes ? (
                    license.cdlInformation.endorsementCodes
                  ) : (
                    <Trans file="Labels" id="None" fallback="None" />
                  ),
                },
              ]}
            />
          </SummaryCard>
          <h2 className="h3">
            <Trans
              file="dps"
              id="cdl_Medical_certification_information"
              fallback="cdl_Medical_certification_information"
            />
          </h2>
          <SummaryCard className="medical-information-card">
            <SummaryCard.List
              items={[
                {
                  label: (
                    <Trans
                      file="Labels"
                      id="SelfCertification"
                      fallback="SelfCertification"
                    />
                  ),
                  value: license.cdlInformation.selfCertification || (
                    <Trans file="Labels" id="None" fallback="None" />
                  ),
                  className: 'word-break',
                },
                {
                  label: <Trans file="Labels" id="Status" fallback="Status" />,
                  value: license.cdlInformation.status || (
                    <Trans file="Dashboard" id="None" fallback="None" />
                  ),
                  className: 'word-break',
                },
              ]}
            />
          </SummaryCard>
          <InputCheckbox
            className="affirmation"
            name="affirmation"
            value={isTermsChecked}
            onChange={e => this.handleCheckboxChange(e)}
            label={
              <Trans
                file="dps"
                id="cdl_ConfirmationDetailsCheckbox"
                fallback="cdl_ConfirmationDetailsCheckbox"
              />
            }
          />

          <FormActions>
            <FormActionsItem>
              <ButtonPrimary
                disabled={!isTermsChecked}
                type="button"
                onClick={() => this.handleConfirmClick()}
              >
                <Trans file="Labels" id="Next" fallback="Next" />
              </ButtonPrimary>
            </FormActionsItem>
            <FormActionsItem>
              <Button type="button" onClick={() => this.handleCancelClick()}>
                <Trans file="Labels" id="Cancel" fallback="Cancel" />
              </Button>
            </FormActionsItem>
          </FormActions>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  // basicInfo: selectAppBasicInfo(state),
  license: state.dps.selected,
});
const mapDispatchToProps = (dispatch: Object) =>
  bindActionCreators({ setTakeoverNavContent, push }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CDLLRConfirmDetails);
